import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DomSanitizer } from '@angular/platform-browser';
import { AHRService, Case, CaseId, CaseState, DossierFileDescriptor, NewsStory, ReviewStep, TaskStatus } from '../../../domain';
import { ConsoleService } from '../../../widgets/console.service';
import { TooltipService } from '../../../widgets/tooltip.service';


@Component({
	selector: 'academic-case-detail',
	templateUrl: './academic-case-detail.component.html',
	styleUrls: ['./academic-case-detail.component.scss']
})
export class AcademicCaseDetailComponent implements OnInit, OnChanges {
	@Input() case: Case = null;
	@Input() resultsVisible: boolean = false;
	CaseState = CaseState;
	news: NewsStory[] = null;
	dossierFiles = { };
	ShowCandidateReviewStage: boolean = false;
	CandidateReviewStep: ReviewStep = null;
	activeTaskName: string = null;
    caseId:CaseId;
	candidateName: string;
	workflowTaskId: number | null = null;
	constructor(
		private svc: AHRService,
		private md: MatDialog,
		private readonly domSanitizer: DomSanitizer,
		private sb: MatSnackBar,
		private console: ConsoleService,
		public tooltipSvc: TooltipService
		) {

		}

	ngOnInit() {
		this.ShowCandidateReviewStage = this.candidateCanAccessReviewStage();
		this.candidateName = this.case.userName;
	}

	ngOnChanges(changes: SimpleChanges): void {
		if('case' in changes){
			let c = <Case>changes['case'].currentValue;
			this.case = c;
			this.caseId = new CaseId(this.case.id,this.case.yearId);
			this.updateWorkflowTaskId();
			this.svc.getNewsStoriesForCurrentUser(c.yearId).subscribe(news => this.news = news);
			this.svc.getCandidateWorkflowFilesForCurrentUser(c.yearId, c.id).subscribe(files => {
				
				// Filter candidate files based on committee access
				const filteredCandidateFiles = files.candidateFiles.filter(file => {
					const committeeName = file.committeeName?.trim().toLowerCase();
					return committeeName && (
						committeeName === "candidate"
						|| files.candidateCanReadFiles.some(c => c.toLowerCase() === committeeName)
					);
				});

				this.dossierFiles[c.yearId] = {
					candidateCanReadFiles: files.candidateCanReadFiles,
					candidateFiles: filteredCandidateFiles,
					reviewerFiles: {}
				};

				this.console.log(this.dossierFiles);
			});	
		}
	}

	getInstructions(): string {
		return this.tooltipSvc.tooltip("AcademicProgramReview.Instructions");
	}
 	
	hasInstructions() {
		if (this.getInstructions().length > 0) {
			return true;
		} 
		return false;
	}
	
	download(file: DossierFileDescriptor){
		//this.svc.downloadDossierFile(this.case.yearId, file.id);
		this.sb.open('Downloading file...',null, {duration: 2000});
		let fileName = file.id;
		this.svc.dossierFileObjectUrl(this.case.yearId, fileName,this.case.id).subscribe(url => {
			//this.openUrlViaClick(url,'_blank');
			//this.openUrlInNewTab(url);
			//PdfviewerModalComponent.open(this.md, 'Case File', this.domSanitizer.bypassSecurityTrustResourceUrl(url))
		});
	}
	openUrlViaClick(url: any, target: string = ''){
		let anchor = window.document.createElement('a');
		anchor.href = url;
		anchor.target = target;
		document.body.appendChild(anchor);
		anchor.click();
		document.body.removeChild(anchor);
	}
	openUrlInNewTab(url: any){
		let win = window.open('/assets/loading.html');
		win.onload = () => {
			win.location.href = url;
		};
	}

	private updateWorkflowTaskId() {
		this.workflowTaskId = null;
		this.activeTaskName = null;
		const activeTask = this.case.reviewStepMetadata?.find(
			p => p.assigneeId == String(this.case.userId) && p.status == TaskStatus.InProgress);
		if (activeTask) {
			this.workflowTaskId = activeTask.taskId;
			this.activeTaskName = activeTask.taskName;
		}
	}

	candidateCanAccessReviewStage(){
		let result = false;
		if(this.case.state == CaseState.InReview){
			this.case.reviewersByStepId.forEach((reviewers, key) => {
				reviewers.forEach((reviewer, index) => {
					if(reviewer.userId == this.case.userId) {
						this.case.reviewSteps.forEach(rs => {
							if(rs.id == key) {
								this.CandidateReviewStep = rs;
							}
						});
						result = true;
					}
				});
			});
		}
		return result;
	}

	showcandidateReviewStep(){
		if(this.CandidateReviewStep != null)
			return this.CandidateReviewStep.longName;
		return " is ready.";
	}

	isCaseWithCandidate(): string {
		if (this.case.yearId <= 2022)
			return "false";

		if (!this.case.reviewStepMetadata || this.case.reviewStepMetadata.length === 0)
			return "pending";

		if (this.workflowTaskId)
			return "true";

		return "false";
	}

}